import React from "react";
import { Link } from "react-router-dom";
import { Award, Factory, Users, Eye, Target, ShieldCheck } from "lucide-react";
import { company } from "../data/mock";

export default function CompanyProfile() {
  return (
    <main>
      {/* Page Header */}
      <section className="brand-navy text-white py-14">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <p className="text-sm uppercase tracking-[0.3em] text-brand-red font-semibold">About</p>
          <h1 className="font-display text-4xl md:text-5xl font-bold mt-2">Company Profile</h1>
          <nav className="text-sm text-white/60 mt-3">
            <Link to="/" className="hover:text-white">Home</Link> / <span className="text-white">Company Profile</span>
          </nav>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <p className="text-sm uppercase tracking-[0.3em] text-brand-red font-semibold mb-3">Who We Are</p>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-brand-navy mb-5">{company.name}</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              <strong>{company.name}</strong> is a leading <strong>manufacturer, supplier, wholesaler and trader</strong> of high-quality foam sheet products based in {company.location}. Established in <strong>{company.established}</strong>, we have been catering to the needs of mattress brands, packaging industries, automotive, and institutional customers across India.
            </p>
            <p className="text-gray-600 leading-relaxed mb-4">
              Our core product range includes <strong>Memory Foam, PU Mattress Foam, High Density Foam, EPE Foam Sheets, FR Foam, Bonded Foam</strong> and customized foam articles. We work closely with leading raw-material vendors to ensure consistent quality and timely delivery.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Today, with a state-of-the-art production unit and a dedicated team, we serve over 200+ wholesale customers across 20 states.
            </p>
          </div>
          <img src="https://images.unsplash.com/photo-1727199079123-ba845d5ab4f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHx3YXJlaG91c2UlMjBmYWN0b3J5fGVufDB8fHx8MTc3NzE3NDY0MHww&ixlib=rb-4.1.0&q=85" alt="Facility" className="w-full h-[480px] object-cover rounded-lg shadow-xl" />
        </div>
      </section>

      {/* Pillars */}
      <section id="pillared" className="bg-[#f7f8fc] py-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <div className="text-center mb-10">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-brand-navy">Our Strength</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { icon: Users, t: "Pillared By Strong Team Work", d: "A team of 30+ skilled professionals working cohesively from production to dispatch." },
              { icon: Factory, t: "Modern Facilities", d: "Sophisticated production line with quality-control labs and 20,000 sq.ft. warehousing." },
              { icon: Award, t: "Quality Assured", d: "Every batch is tested for density, ILD, resilience and dimensional stability." },
            ].map(({ icon: Icon, t, d }, i) => (
              <div key={i} className="bg-white p-7 rounded-lg shadow-sm hover:shadow-md transition-shadow border border-gray-100">
                <div className="w-14 h-14 rounded-md bg-[#f5f6fb] flex items-center justify-center mb-4">
                  <Icon size={26} className="text-brand-red" />
                </div>
                <h3 className="text-lg font-bold text-brand-navy mb-2">{t}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Vision Mission */}
      <section id="facilities" className="max-w-[1400px] mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white p-8 rounded-lg border border-gray-100 shadow-sm">
            <Eye size={32} className="text-brand-red mb-3" />
            <h3 className="text-2xl font-bold text-brand-navy mb-3">Our Vision</h3>
            <p className="text-gray-600 leading-relaxed">To be the most trusted and preferred foam sheet manufacturer in India, delivering uncompromised quality, innovation and customer service to every wholesale partner we serve.</p>
          </div>
          <div className="bg-white p-8 rounded-lg border border-gray-100 shadow-sm">
            <Target size={32} className="text-brand-red mb-3" />
            <h3 className="text-2xl font-bold text-brand-navy mb-3">Our Mission</h3>
            <p className="text-gray-600 leading-relaxed">To consistently produce premium quality foam products at the best wholesale prices, supported by reliable logistics, dedicated customer service and continuous innovation in foam technology.</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="brand-navy text-white py-14">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <h3 className="font-display text-2xl md:text-3xl font-bold">Looking for a reliable foam sheet partner?</h3>
          <Link to="/contact-us" className="btn-red-brand px-7 py-3 rounded-md text-sm font-semibold">Contact Us Today</Link>
        </div>
      </section>
    </main>
  );
}
